import { Component, OnInit, Input, inject, Signal } from '@angular/core';
import { LOTTO_STATE, LOYALTY_STATUS, LottoV2Query, ItemLoyaltyState, LottoUIStatus, Lotto, LottoFacade } from '@fgb/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';

@Component({
  selector: 'fgbcl-lottos-list-item-v2',
  standalone: true,
  imports: [
    CommonModule,
    LoyaltyIconModule,
    PipesModule,
    DirectivesModule,
    RouterModule,
    CarouselModule,
    FGBSharedModule,
    CountdownV2Component,
  ],
  templateUrl: './lottos-list-item-v2.component.html',
  styleUrl: './lottos-list-item-v2.component.scss',
})
export class LottosListItemV2Component implements OnInit {
  @Input() lottoItem: Lotto;
  @Input() ignoreLink: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() featuredIcon: string = 'star';
  LOTTO_STATE = LOTTO_STATE;
  state = LOYALTY_STATUS;
  ItemLoyaltyState = ItemLoyaltyState;
  lottoStatus: Signal<LottoUIStatus | undefined>;

  private readonly lottoQuery = inject(LottoV2Query);
  private readonly lottoFacade = inject(LottoFacade);

  ngOnInit() {
    if (!this.isPreview) {
      this.lottoStatus = this.lottoQuery.getStatusById(this.lottoItem.LottoId);
    }
  }

  /** When the lotto or countdown ends, remove the lotto item from the store */
  onLottoEnd(): void {
    this.lottoFacade.removeById(this.lottoItem.LottoId);
  }
}
